
import { waitForElm, getCookie, setCookie } from '../assets/helpers.js';

(() => {

  const newsletter = document.querySelector("[data-newsletter-improved-popup]");

  if (newsletter) {
  window.nlImproved = {

    popup: document.querySelector("[data-newsletter-improved-popup]"),

    classes: {
      show: "display-modal"
    },
    selectors: {
      header: ".pageheader",
      sClose: "nl-popoup-closed",
      sLastPage: "last-page-view",
      pOptIn: "nl-opt-in"
    },
    isMobile: window.innerWidth < 768,
    navCount: sessionStorage.getItem('nl-nav-counter') || 0,
    lastPageView: sessionStorage.getItem('last-page-view') || "",
    haveBeenClosed: getCookie('nl-popoup-closed') || false,
    optInBannerTemplate: `<div class='newsletter-improved__optin-banner'>
      <div class='newsletter-improved__optin-banner-header'><i class='newsletter-improved__icon-close icon-close'></i></div>
      <div>
        <p>{{text}}</p>
      </div>
    </div>`,
    updatePageViewAndHystory: () => {
      // Counter only increment when visiting a different page (avoid increment on refresh page)
      sessionStorage.setItem('last-page-view', window.location.href);

      if (
        window.location.href != window.nlImproved.lastPageView &&
        !window.nlImproved.checkPageExclusion()
      ) {
        sessionStorage.setItem("nl-nav-counter", parseInt(window.nlImproved.navCount) + 1);
      }
    },
    checkPageExclusion: () => {
      const currentPage = window.location.pathname;
      const excludedPages = window.nlImproved.popup.dataset.excludedPages.split(',');

      for (let i = 0; i < excludedPages.length; i++) {
        if(excludedPages[i].trim() == currentPage.trim()) {
          return true;
        }
      }
      return false;
    },
    checkShowByStep: () => {
      if (sessionStorage.getItem("nl-nav-counter") >= window.nlImproved.popup.dataset.showDelay){
        return true;
      }
      return false;
    },
    resetCounter: () => {
      sessionStorage.setItem("nl-nav-counter", 0);
    },
    show: () => {
      window.nlImproved.popup.style.display = '';
      window.nlImproved.popup.classList.add(window.nlImproved.classes.show);
      window.nlImproved.showMobileSubmitBtn();
    },
    hide: () => {
      window.nlImproved.popup.classList.remove(window.nlImproved.classes.show);
    },
    attachScroll: () => {
      document.addEventListener("scroll", () => {
        if (!getCookie('nl-popoup-closed'))
          window.nlImproved.show();
      });
    },
    checkOptin: () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      const optInParam = urlParams.get(window.nlImproved.selectors.pOptIn);
      const customerPosted = urlParams.get('customer_posted');

      if (optInParam) {
        window.nlImproved.renderNotificationBanner();

        setCookie('nl-popoup-closed', true, window.nlImproved.popup.dataset.cookieExpire)

      } else if (customerPosted) {

        setCookie('nl-popoup-closed', true, window.nlImproved.popup.dataset.cookieExpire)
      }
    },
    renderNotificationBanner: () => {
      let elementHeader = document.querySelector(window.nlImproved.selectors.header);
      let optInBanner = document.createElement("div");

      optInBanner.innerHTML += window.nlImproved.optInBannerTemplate.replace('{{text}}', window.nlImproved.popup.dataset.optinBannerText);

      const iconClose = optInBanner.querySelector('.icon-close');
      iconClose.addEventListener('click', () => {
        optInBanner.style.display = 'none';
      });

      elementHeader.append(optInBanner);
    },

    attachCloseEvent: () => {

      window.nlImproved.popup.querySelector('.icon-close').addEventListener('click', () => {
        window.nlImproved.hide();
        window.nlImproved.resetCounter();
        const sticky = document.getElementById('improved-newsletter-stiky');

        if (sticky)
          sticky.style.display = 'none';

        setCookie('nl-popoup-closed', true, window.nlImproved.popup.dataset.cookieExpire)
      });
    },
    showMobileSubmitBtn: () => {

      const news_improved_image = window.nlImproved.popup.querySelector('.newsletter-improved__image');
      const news_improved_form_container = window.nlImproved.popup.querySelector('.newsletter-improved__form-container');
      const news_improved_form = window.nlImproved.popup.querySelector('#create_customer');
      news_improved_form.addEventListener('submit', (event) => {

        waitForElm('.success-button').then((elm) => {
          news_improved_form_container.classList.add('newsletter-success');
          news_improved_image.style.display = 'none';

          elm.addEventListener('click', e => {
            window.nlImproved.hide();

            setCookie(window.nlImproved.selectors.sClose, true, window.nlImproved.popup.dataset.cookieExpire)
          });

          elm.querySelector('a').addEventListener('click', e => {
            e.preventDefault();
            window.nlImproved.hide();

            setCookie(window.nlImproved.selectors.sClose, true, window.nlImproved.popup.dataset.cookieExpire)
          });
        });
        


        const mailchimpForm = window.nlImproved.popup.querySelector('#imp_nl_mc_form');
        const createCustomerForm = window.nlImproved.popup.querySelector('#create_customer');

        mailchimpForm.querySelector("input[type=email]").value = createCustomerForm.querySelector("input[type=email]").value;

      });


      if (window.innerWidth < 768) {

        waitForElm('.newsletter-improved__modal .cf-react-target > .cf-form-inner > .cf-form-step > .cf-fields-container > .newsletter__input').then((elm) => {

          let news_improved_svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          news_improved_svg.innerHTML = `<path d="M24 16.5L18 24.5L24 32.5" stroke="#1C1C1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 24.5L37.5 24.5" stroke="#1C1C1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`
          let news_improved_div = document.createElement("a");
          news_improved_div.className = "newsletter-improved__mobile-btn";

          news_improved_div.appendChild(news_improved_svg);
          news_improved_div.addEventListener('click', (event) => {
            const myEvt = new Event('submit', {bubbles: true});
            news_improved_form.dispatchEvent(myEvt);
          });

          elm.appendChild(news_improved_div);
        });

      }
    },
    init: () => {

      window.nlImproved.checkOptin();

      // Nell'editor del tema il popup si apre selezionando la sua sezione e si
      // chiude deselezionandola, come fa gia' pop-up.js. Senza questo ramo era
      // impossibile vederlo dall'editor: le condizioni normali richiedono due
      // cambi pagina effettivi e l'assenza del cookie di chiusura, che dura 20
      // giorni. Il contatore non viene toccato, cosi' l'anteprima non altera
      // cio' che vedra' il cliente.
      const editorSection = (window.Shopify && window.Shopify.designMode)
        ? window.nlImproved.popup.closest('.shopify-section')
        : null;

      // Il wrapper si cerca prima di prendere questo ramo: non trovandolo, i
      // listener non scatterebbero mai e il flusso normale verrebbe comunque
      // saltato, lasciando il popup invisibile senza alcun segnale.
      if (editorSection) {
        const section = editorSection;

        document.addEventListener('shopify:section:select', (evt) => {
          if (evt.target === section) {
            window.nlImproved.show();
            window.nlImproved.attachCloseEvent();
          }
        });

        document.addEventListener('shopify:section:deselect', (evt) => {
          if (evt.target === section) window.nlImproved.hide();
        });

        return;
      }

      window.nlImproved.updatePageViewAndHystory();

      if (
        window.nlImproved.checkShowByStep()
        &&
        !window.nlImproved.checkPageExclusion()
        &&
        !window.nlImproved.haveBeenClosed
      ){

        if (
          window.nlImproved.popup.dataset.showOnScroll == "true"
        ) {
          window.nlImproved.attachScroll();
        } else {
          window.nlImproved.show();
        }

        window.nlImproved.attachCloseEvent();
      }
    }
  }
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (window.nlImproved)
      window.nlImproved.init();
  });

})();
